import { Moon, Sun } from 'lucide-react';
import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';

export function ThemeToggle() {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  const current = mounted ? (theme === 'system' ? resolvedTheme : theme) : 'dark';
  return (
    <button
      type="button"
      aria-label={`Theme: ${current}`}
      onClick={() => setTheme(current === 'dark' ? 'light' : 'dark')}
      className="inline-flex h-9 w-9 items-center justify-center rounded-md text-fg-muted hover:bg-bg-subtle hover:text-fg"
    >
      <Sun className={cn('h-4 w-4 transition-all', mounted && current === 'dark' ? 'rotate-90 scale-0' : 'scale-100')} />
      <Moon className={cn('-ml-4 h-4 w-4 transition-all', mounted && current === 'dark' ? 'scale-100' : '-rotate-90 scale-0')} />
    </button>
  );
}